/*
 * PROD-7828 R9 — pure request builders for the upload endpoints. request_fields.test.js checks each
 * one sends EXACTLY the fields its goserver handler reads (CD-139). Apply and discard carry no version:
 * the run uuid is the idempotency key and the server re-checks the status under its lock (CD-173).
 */
import { api_pay_month } from '../params';
import { UPLOAD_LIMITS } from './params';

// multipart fields of POST /additional/upload/validate; to_form_data turns them into the body.
export const validate_fields = (file, pay_month) => ({ file, pay_month: api_pay_month(pay_month) });

export const to_form_data = (fields) => {
  const form = new FormData();
  Object.keys(fields).forEach((k) => form.append(k, fields[k]));
  return form;
};

export const run_params = (run_uuid) => ({ run_uuid });

export const file_params = (run_uuid) => ({ run_uuid });

export const runs_params = (pay_month, limit = UPLOAD_LIMITS.RUNS_LIMIT_DEFAULT, offset = 0) => ({
  pay_month: api_pay_month(pay_month),
  limit: Math.min(limit || UPLOAD_LIMITS.RUNS_LIMIT_DEFAULT, UPLOAD_LIMITS.RUNS_LIMIT_MAX),
  offset: offset || 0
});

/*
 * R9-C4: each tick acknowledges a COUNT, not a flag. An unticked box sends 0, so a file whose counts
 * changed since the preview (a re-upload) is refused rather than applied on an old acknowledgement.
 */
export const apply_payload = (run, ticks) => {
  const counts = (run && run.counts) || {};
  const t = ticks || {};
  return {
    run_uuid: run.run_uuid,
    skip_invalid_count: t.skip_invalid ? counts.invalid || 0 : 0,
    confirm_large_count: t.confirm_large ? counts.confirm_large || 0 : 0,
    confirm_lookalike_count: t.confirm_lookalike ? counts.lookalike || 0 : 0
  };
};

export const discard_payload = (run_uuid, reason) => ({
  run_uuid,
  reason: String(reason || '').trim()
});

// POST /recalc (CD-33): one teacher per call, month as 'YYYY-MM-01' like every R9 endpoint.
export const recalc_payload = (teacher_uuid, pay_month) => ({
  teacher_uuid,
  pay_month: api_pay_month(pay_month)
});
